/* eslint-disable react-hooks/exhaustive-deps */
import MUIDataTable from "mui-datatables";
import { useEffect, useState } from "react";

import BusinessUnitTable from "./components/BusinessUnitTable/BusinessUnitTable";
import LoadingOverlay from "./components/LoadingOverlay";
import ProductFamilyTable from "./components/ProductFamilyTable/ProductFamilyTable";
import WaterfallSection from "./components/waterfall/WaterfallSection";

const TOTAL_COMPONENTS = 4;

const MetricsTab = (props) => {
    const [metricTableData, setMetricTableData] = useState([]);
    const [asOfDate, setAsOfDate] = useState(new Date().toISOString().split("T")[0]);
    const [isLoading, setIsLoading] = useState(true);
    const [loadedCount, setLoadedCount] = useState(0);

    const handleComponentLoaded = () => {
        setLoadedCount((prev) => prev + 1);
    };

    const allLoaded = loadedCount >= TOTAL_COMPONENTS;

    const formatTableData = (data) => {
        return data.map((item) => {
            const formattedItem = {
                ...item,
                paid_customer_count: item.paid_customer_count.toLocaleString("en-US"),
                ending_carr:
                    typeof item.ending_carr === "number"
                        ? `$${item.ending_carr.toLocaleString("en-US", {
                              minimumFractionDigits: 2,
                          })}`
                        : item.ending_carr,
            };

            // Bold the Total row
            if (item.product === "Total") {
                formattedItem.product = <strong>{item.product}</strong>;
                formattedItem.paid_customer_count = (
                    <strong>{formattedItem.paid_customer_count}</strong>
                );
                formattedItem.ending_carr = <strong>{formattedItem.ending_carr}</strong>;
            }

            return formattedItem;
        });
    };

    const fetchMetricsForDate = (date) => {
        setIsLoading(true);
        props
            .fetchData("getmetrics", { date })
            .then((data) => {
                const carrData = data.values?.carr || [];
                setMetricTableData(formatTableData(carrData));
            })
            .catch((error) => console.error("Error fetching metrics:", error))
            .finally(() => {
                setIsLoading(false);
                handleComponentLoaded();
            });
    };

    useEffect(() => {
        if (props.data && props.data.carr) {
            setMetricTableData(formatTableData(props.data.carr));
            setIsLoading(false);
            handleComponentLoaded();
        }
    }, [props.data]);

    const handleDateChange = (e) => {
        setAsOfDate(e.target.value);
    };

    const handleRefreshClick = () => {
        fetchMetricsForDate(asOfDate);
    };

    const columns = [
        {
            name: "product",
            label: "Product",
            options: {
                setCellProps: () => ({
                    style: {
                        minWidth: "fit-content",
                        width: "50%",
                    },
                }),
                setCellHeaderProps: () => ({
                    style: {
                        width: "50%",
                        minWidth: "fit-content",
                        fontWeight: "bold",
                    },
                }),
            },
        },
        {
            name: "paid_customer_count",
            label: "Paid Customers",
            options: {
                setCellProps: () => ({
                    style: {
                        minWidth: "fit-content",
                        textAlign: "right",
                    },
                }),
                setCellHeaderProps: () => ({
                    style: {
                        minWidth: "200px",
                        fontWeight: "bold",
                    },
                }),
            },
        },
        {
            name: "ending_carr",
            label: "Ending CARR",
            options: {
                setCellProps: () => ({
                    style: {
                        minWidth: "120px",
                        textAlign: "right",
                    },
                }),
                setCellHeaderProps: () => ({
                    style: {
                        minWidth: "135px",
                        textAlign: "right",
                        fontWeight: "bold",
                    },
                }),
            },
        },
    ];

    const options = {
        responsive: "standard",
        selectableRows: "none",
        searchAlwaysOpen: true,
        storageKey: "metricsTable",
        filter: false,
        sort: false,
        viewColumns: false,
        print: false,
        download: false,
        search: false,
        columnOrder: null,
        fixedHeader: true,
        pagination: false,
    };

    return (
        <>
            {!allLoaded && <LoadingOverlay text="Loading metrics..." />}
            <div
                className="flex w-full flex-col"
                style={{ visibility: allLoaded ? "visible" : "hidden" }}
            >
                <div className="mb-4 mt-4 flex items-center justify-between">
                    <h2>CARR by Product</h2>
                    <div className="flex items-center">
                        <label htmlFor="asOfDate" style={{ fontSize: "14px" }}>
                            As of Date:&nbsp;
                        </label>
                        <input
                            type="date"
                            id="asOfDate"
                            value={asOfDate}
                            onChange={handleDateChange}
                            style={{
                                border: "1px solid #ccc",
                                padding: "4px",
                                borderRadius: "4px",
                                marginRight: "8px",
                                fontSize: "14px",
                            }}
                        />
                        <button
                            onClick={handleRefreshClick}
                            title="Refresh"
                            onMouseEnter={(e) =>
                                (e.currentTarget.style.backgroundColor = "#0056b3")
                            }
                            onMouseLeave={(e) =>
                                (e.currentTarget.style.backgroundColor = "#007bff")
                            }
                            style={{
                                padding: "10px",
                                marginRight: "10px",
                                borderRadius: "4px",
                                backgroundColor: "#007bff",
                                color: "#fff",
                                border: "none",
                                cursor: "pointer",
                                transition: "background-color 0.2s",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <i className="fas fa-sync-alt"></i>
                        </button>
                    </div>
                </div>
                <div className="relative min-h-[200px]">
                    {isLoading && <LoadingOverlay contained text="Loading metrics..." />}
                    {metricTableData.length > 0 ? (
                        <MUIDataTable
                            data={metricTableData}
                            columns={columns}
                            options={options}
                            style={{ marginTop: "80px" }}
                            className="ngShadow"
                        />
                    ) : (
                        !isLoading && (
                            <h3 className="px-2 pt-8 text-center">No metrics available.</h3>
                        )
                    )}
                </div>
                <ProductFamilyTable props={props} onLoad={handleComponentLoaded} />
                <BusinessUnitTable props={props} onLoad={handleComponentLoaded} />
                <WaterfallSection props={props} onLoad={handleComponentLoaded} />
            </div>
        </>
    );
};

export default MetricsTab;
